/* eslint-disable @typescript-eslint/no-explicit-any */

export const formatOptionLabel = (option: any, { context }: any) => {
  if (context === 'value') {
    return option.label.length > 15 ? `${option.label.substring(0, 15)}...` : option.label;
  }
  return option.label;
};
